// tslint:disable: triple-equals
import { getPerformance } from './../../../requests/assessements';
import React, { useEffect, useState } from 'react';
import { getCustomScores } from '../../Dashboard/apiCaller';
import { translatePerformanceClassificationLabel } from '../../../enums/labels/PerformanceClassification';
import { showErrorMessage } from '../../../helpers/showMessage';
import { isUnauthorized } from '../../../utils/common';
import { hasAssessmentCheck } from '../../../helpers/handleBrandAndHotelData';
import { StandardPerformanceSelectorContainer } from './StandardPerformanceSelector.styled';
import { DropdownSingle } from './../../../app/common/sharedComponents/DropdownSingle';
import { IDropdownOption } from '../../../app/@types/dropdown';
import { ICustomScoreType } from '../../../app/@types/customScores';

export const StandardPerformaceSelector = ({
  selectedHotel,
  selectedAssessment,
  setStandard,
  standard,
  selectedClient,
  setPerformaceClassification,
  performanceClassification,
  isSelf,
}) => {
  const [customScores, setCustomScores] = useState<IDropdownOption[]>([]);
  const [performace, setPerformance] = useState<any>([]);

  useEffect(() => {
      const hasAssessment = !!isSelf || hasAssessmentCheck();
      if (selectedHotel && hasAssessment) {
        getCustomScores(selectedHotel)
          .then((response) => {
            convertCustomScores(response);
          })
          .catch((e) => {
            showErrorMessage(
              'Could not find Custom Scores',
              !isUnauthorized(e)
            );
          });
      }
      if (selectedAssessment && standard) {
        getPerformance(selectedAssessment, standard)
          .then((res) => {
            fetchPerformance(res);
          })
          .catch((er) => {
            showErrorMessage('Could not find Performance', !isUnauthorized(er));
          });
      }
  }, [selectedAssessment, selectedHotel, standard]);

  function convertCustomScores (customScoresResponse: ICustomScoreType[]) {
    let customList: IDropdownOption[] = [];

    if (customScoresResponse && customScoresResponse.length > 0) {
      customList = customScoresResponse.map((item) => ({
        value: item.customScoreName === 'Benchmark'  ? 'LQA' : item.customScoreNumber,
        label: item.customScoreName,
      }));
    }
    setCustomScores(customList);
  }

  function fetchPerformance (response: any[]) {
    let performanceList: { value: string; label: string }[] = [];

    if (Array.isArray(response) && response.length > 0) {
      performanceList = response
        .filter(
          (item) => item.performanceClassifier === 'performanceClassifier'
        )
        .map((item) => ({
          value: item.performanceClassifierLabel,
          label: translatePerformanceClassificationLabel(
            item.performanceClassifierLabel
          ),
        }));
    }
    performanceList.push({
      value: 'all',
      label: 'Performance',
    });
    setPerformance(performanceList);
  }

  return (
    <StandardPerformanceSelectorContainer>
      <DropdownSingle
        defaultOption={customScores.find(
          (option) => option.value === standard
        )}
        options={customScores}
        isClearable={false}
        isSearchable={false}
        callback={(event) => {
          setStandard(event.value);
        }}
      />
      {performace && standard === 'LQA' && (
        <DropdownSingle
          isSearchable={false}
          defaultOption={
            performace.find(
              (option) => option.value === performanceClassification
            ) || performace[0]
          }
          options={performace}
          isClearable={false}
          callback={(event) => {
            setPerformaceClassification(event.value);
          }}
        />
      )}
    </StandardPerformanceSelectorContainer>
  );
};
